export { default as amplify_admin_conf } from './amplify.admin.conf.js';
export { default as amplify_user_conf } from './amplify.user.conf.js';
export { default as amplify_conf } from './amplify.conf.js';
export { default as initI18n } from './i18n.conf.js';



// WEBPACK FOOTER //
// ./src/conf/index.js